import { Controller, RegisterOptions, useFormContext } from "react-hook-form"
import { CheckBoxLabelInputWrapper } from "./styles"

interface ICardCheckboxProps {
	id: string // Checkbox ID
	title: string
	name: string // Form field name
	registerOptions?: RegisterOptions
}

export default function CheckBoxLabelInput({
	id,
	title,
	name,
	registerOptions,
}: ICardCheckboxProps) {
	const { control } = useFormContext()
	return (
		<CheckBoxLabelInputWrapper>
			<Controller
				control={control}
				name={name}
				rules={registerOptions}
				render={({ field: { onChange, value = [] } }) => {
					const isChecked = value.includes(id)
					const handleCheckboxChange = () => {
						if (isChecked) {
							onChange(value.filter((item: string) => item !== id))
						} else {
							onChange([...value, id])
						}
					}

					return (
						<div className={`card ${isChecked ? "selected" : ""}`}>
							<input
								type='checkbox'
								id={id}
								className='card-checkbox'
								checked={isChecked}
								onChange={handleCheckboxChange}
							/>
							<label htmlFor={id} className='card-label'>
								<p className='card-title'>{title}</p>
							</label>
						</div>
					)
				}}
			/>
		</CheckBoxLabelInputWrapper>
	)
}
